import { graphql } from "../../../services/wp.api.service";

const query = `
mutation VerifyUserEmail($username: String!, $verificationKey: String!, $email: String = "") {
	verifyUserEmail(input: {username: $username, verificationKey: $verificationKey, email: $email}) {
		authToken
		refreshToken
		message
		success
		user {
			email
			jwtAuthToken
			jwtRefreshToken
		}
	}
}
`;

const verifyEmailMutation = (useMutation, options) => useMutation(
	"verifyEmail",
	(variables) => graphql({
		query,
		variables
	}, true),
	options
);

export default verifyEmailMutation;
